<script>

import ProductCompareHelper from "../../helpers/productCompareHelper";

export default
    {
        name: 'ProductCompareParam',
    
        props: [
            'value',
            'suffix',
            'compute',
            'computeParams'
        ],

        data() {
            return {
            };
        },
    
        computed: {
            formattedValue() {
                return ProductCompareHelper.getValue(this.value, this.compute, this.computeParams);
            }
        },
    
}

</script>

<template>
    <div class="pc-modal-item__param js-pc-modal-item__param default-bg">{{formattedValue}} {{suffix}}</div>
</template>
